export default function DriveIcon({
  strokeWidth,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      viewBox="0 0 30 31"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m27.825 22.574-.395 4.903a.668.668 0 0 1-.663.608h-1.302a.667.667 0 0 1-.664-.663v-4.469l1.516-.19 1.508-.189Z"
        fill="#31445B"
      />
      <path
        d="m27.825 22.574-.395 4.903a.668.668 0 0 1-.663.608h-.45v-5.321l1.508-.19Z"
        fill="#1D2943"
      />
      <path
        d="M7.472 22.953v4.61a.52.52 0 0 1-.52.521H3.153a.518.518 0 0 1-.521-.473l-.458-5.092 2.858.236 2.44.198Z"
        fill="#31445B"
      />
      <path
        d="M5.033 22.755v5.33H3.154a.518.518 0 0 1-.521-.474l-.458-5.092 2.858.236ZM24.8 22.952v4.338a.795.795 0 0 1-.795.795H8.27a.795.795 0 0 1-.794-.795v-4.338H24.8Z"
        fill="#1D2943"
      />
      <path
        d="m25.848 4.316 1.97 18.016a1.57 1.57 0 0 1-1.562 1.741H3.744a1.57 1.57 0 0 1-1.56-1.741L4.151 4.316a1.57 1.57 0 0 1 1.561-1.4h18.574a1.57 1.57 0 0 1 1.561 1.4Z"
        fill="#4C5C75"
      />
      <path
        d="M9.84 24.987v2.222a.445.445 0 0 1-.734.336h-.002a.441.441 0 0 1-.154-.336v-2.222c0-.287.266-.493.534-.437h.001a.447.447 0 0 1 .355.437Z"
        fill="#9EA9C9"
      />
      <path
        d="M9.64 24.886v2.222a.445.445 0 0 1-.534.437h-.002a.441.441 0 0 1-.154-.336v-2.222c0-.287.266-.493.534-.437h.001l.023.022a.44.44 0 0 1 .131.314Z"
        fill="#C9CEE2"
      />
      <path
        d="M11.25 24.987v2.222a.445.445 0 0 1-.735.336h-.002l-.023-.022a.44.44 0 0 1-.13-.314v-2.222c0-.59.89-.584.89 0Z"
        fill="#9EA9C9"
      />
      <path
        d="M11.049 24.887v2.222a.445.445 0 0 1-.534.436h-.002l-.023-.022a.439.439 0 0 1-.13-.314v-2.222c0-.246.199-.445.444-.445.046 0 .057.004.09.009.093.077.155.2.155.336Z"
        fill="#C9CEE2"
      />
      <path
        d="M12.66 24.987v2.222a.445.445 0 0 1-.735.336h-.002a.44.44 0 0 1-.154-.336v-2.222c0-.287.266-.493.534-.437h.001a.447.447 0 0 1 .355.437Z"
        fill="#9EA9C9"
      />
      <path
        d="M12.458 24.886v2.222a.445.445 0 0 1-.533.437h-.002a.44.44 0 0 1-.154-.336v-2.222c0-.287.266-.493.534-.437h.001c.092.077.154.201.154.336Z"
        fill="#C9CEE2"
      />
      <path
        d="M14.069 24.987v2.222a.445.445 0 0 1-.735.336h-.001l-.024-.022a.44.44 0 0 1-.13-.314v-2.222c0-.59.89-.584.89 0Z"
        fill="#9EA9C9"
      />
      <path
        d="M13.868 24.887v2.222a.445.445 0 0 1-.534.436h-.001c-.01-.007-.016-.015-.024-.022a.439.439 0 0 1-.13-.314v-2.222c0-.246.199-.445.444-.445.046 0 .058.004.09.009.093.077.155.2.155.336Z"
        fill="#C9CEE2"
      />
      <path
        d="M15.478 24.986v2.222a.444.444 0 0 1-.734.336h-.002a.441.441 0 0 1-.154-.336v-2.222c0-.589.89-.582.89 0Z"
        fill="#9EA9C9"
      />
      <path
        d="M15.277 24.886v2.222c0 .25-.21.484-.535.437a.441.441 0 0 1-.154-.336v-2.222c0-.287.266-.493.534-.437h.001c.093.077.155.201.155.336Z"
        fill="#C9CEE2"
      />
      <path
        d="M16.888 24.987v2.222a.445.445 0 0 1-.735.336h-.001a.441.441 0 0 1-.154-.336v-2.222c0-.287.265-.493.533-.437h.002a.447.447 0 0 1 .355.437Z"
        fill="#9EA9C9"
      />
      <path
        d="M16.687 24.886v2.222c0 .246-.2.445-.445.445-.046 0-.057-.004-.09-.008a.441.441 0 0 1-.154-.336v-2.222c0-.287.265-.493.533-.437h.002l.023.022c.081.08.13.192.13.314Z"
        fill="#C9CEE2"
      />
      <path
        d="M18.297 24.987v2.222a.444.444 0 0 1-.734.336h-.002a.441.441 0 0 1-.154-.336v-2.222c0-.287.266-.493.534-.437h.001a.447.447 0 0 1 .355.437Z"
        fill="#9EA9C9"
      />
      <path
        d="M18.097 24.886v2.222c0 .25-.21.484-.536.437a.441.441 0 0 1-.154-.336v-2.222c0-.287.266-.493.534-.437h.001l.024.022a.44.44 0 0 1 .13.314Z"
        fill="#C9CEE2"
      />
      <path
        d="M23.157 26.215a1.182 1.182 0 1 1-2.365 0 1.182 1.182 0 0 1 2.365 0Z"
        fill="#F1F6FA"
      />
      <path
        d="M22.978 25.757a1.182 1.182 0 0 1-2.168.65 1.182 1.182 0 0 1 2.152-.842c.01.062.016.127.016.192Z"
        fill="#78E75A"
      />
      <path
        d="M25.042 15.794c0 2.882-2.379 5.357-5.757 6.409-.124.039-.25.076-.377.11-4.996 1.363-10.218-.622-11.986-4.035a4.747 4.747 0 0 1-.118-.243c-1.326-2.861-.034-6.612 4.5-8.393.926-.357 3.188-.971 4.631-1.897a2.945 2.945 0 0 0 1.347-2.322 1.244 1.244 0 0 1 1.242-1.18h2.895a1.231 1.231 0 0 1 .824.313c.239.213.397.516.417.857l.333 5.527c.019.316.144.64.37.878 1.098 1.167 1.679 2.543 1.679 3.976Z"
        fill="#C9CEE2"
      />
      <path
        d="M19.285 22.204c-.124.039-.25.075-.377.11-4.995 1.363-10.218-.623-11.986-4.035a4.667 4.667 0 0 1-.118-.243l.633-.548c3.829 3.214 10.904 3.506 10.904 3.506l.944 1.21Z"
        fill="#E3E7F0"
      />
      <path
        d="m18.908 22.314-1.003-1.062c10.032-3.424 4.556-9.385 4.556-9.385l.64-.46c.063.158.158.3.262.411 3.544 3.766 1.24 8.935-4.455 10.496ZM8.358 16.89 6.922 18.28c-1.528-2.946-.236-6.823 4.382-8.636l.802.124s-5.849 3.506-3.748 7.124Z"
        fill="#9EA9C9"
      />
      <path
        d="m17.996 4.361-.398 3.63-6.252 1.849-.585.032c.677-.307.785-.306 2.27-.828.823-.29 1.953-.687 2.904-1.298a2.945 2.945 0 0 0 1.347-2.322c.024-.448.286-.86.714-1.063ZM23.186 11.58l-.944.57-.683-7.899a1.243 1.243 0 0 1 1.101 1.162l.333 5.527c.013.23.08.45.193.64Z"
        fill="#B0B8CF"
      />
      <path
        d="m22.242 4.556-.525.526s-3.069-.114-3.198-.083c-.077.02-.502-.225-.82-.443.22-.195.51-.313.825-.313h2.895c.315 0 .603.117.823.313Z"
        fill="#9EA9C9"
      />
      <path
        d="M24.557 15.485c0 3.57-3.979 6.462-8.885 6.462-4.908 0-8.885-2.893-8.885-6.462 0-2.692 2.263-5 5.483-5.972.002 0 .163-.044.192-.056.821-.33 2.41-.764 3.735-1.614 1.578-1.01 1.593-2.784 1.57-2.705a.759.759 0 0 1 .757-.72h2.895a.76.76 0 0 1 .758.714l.332 5.528c.026.44.2.86.501 1.18.976 1.038 1.547 2.293 1.547 3.645Z"
        fill="#C9CEE2"
      />
      <path
        d="M18.725 15.358c0 .159-.024.313-.07.461-.297.966-1.514 1.668-3.011 1.668-1.385 0-2.527-.6-2.929-1.451-.1-.213-.153-.44-.153-.678 0-1.193 1.353-2.128 3.082-2.128 1.727 0 3.081.935 3.081 2.128Z"
        fill="#F1F6FA"
      />
      <path
        d="M18.655 15.82c-.297.965-1.514 1.668-3.011 1.668-1.384 0-2.527-.6-2.928-1.452l.625-1.201 4.644.093.67.892Z"
        fill="#9EA9C9"
      />
      <path
        d="M18.046 15.273c0-.847-1.075-1.534-2.402-1.534-1.328 0-2.403.687-2.403 1.534 0 .849 1.075 1.536 2.403 1.536 1.327 0 2.402-.688 2.402-1.536Z"
        fill="#C9CEE2"
      />
      <path
        d="M16.304 5.39c-1.09 1.19-3.63 3.309-8.372 4.138A1.288 1.288 0 0 1 6.424 8.26V5.393c0-.727.593-1.293 1.293-1.293h8.022a.76.76 0 0 1 .703.46.759.759 0 0 1-.138.83Z"
        fill="#E3E7F0"
      />
      <path
        d="m7.519 9.081-.327.357a1.289 1.289 0 0 1-.768-1.179V5.393c0-.324.125-.627.298-.824l.508.624.289 3.888Z"
        fill="#9EA9C9"
      />
      <path
        d="m16.347 4.4-.332.359-8.546.824-.81-.93c.23-.331.62-.552 1.058-.552h8.022c.245 0 .466.11.608.298Z"
        fill="#8B95AF"
      />
      <path
        d="M6.942 8.23V5.364c0-.5.405-.905.905-.905h8.022c.332 0 .505.395.28.64-.985 1.073-3.458 3.198-8.154 4.018a.9.9 0 0 1-1.053-.887ZM5.103 11.694c-.439 0-.877-.257-.819-.648.044-.294.388-.516.819-.516.43 0 .774.222.819.516.058.392-.38.648-.82.648Z"
        fill="#C9CEE2"
      />
      <path
        d="M5.922 11.046c-.046.295-.388.516-.82.516-.43 0-.773-.221-.818-.516.044-.294.388-.516.819-.516.43 0 .775.222.819.516Z"
        fill="#F1F6FA"
      />
      <path
        d="M5.628 11.02c0 .197-.236.359-.527.359-.292 0-.527-.162-.527-.36 0-.196.235-.357.527-.357.292 0 .527.161.527.358Z"
        fill="#1D2943"
      />
      <path
        d="M5.58 11.02c0 .159-.213.289-.477.289-.265 0-.478-.13-.478-.29 0-.159.213-.289.478-.289.264 0 .478.13.478.29Z"
        fill="#31445B"
      />
      <path
        d="M5.08 10.91c0 .06-.08.11-.177.11-.097 0-.176-.05-.176-.11s.079-.11.176-.11c.098 0 .176.05.176.11Z"
        fill="#F1F6FA"
        opacity=".52"
      />
      <path
        d="M3.898 22.298c-.507 0-1.013-.297-.946-.748.051-.34.448-.596.946-.596.497 0 .894.256.945.596.068.453-.438.748-.945.748Z"
        fill="#C9CEE2"
      />
      <path
        d="M4.843 21.55c-.052.34-.448.596-.945.596-.498 0-.894-.256-.946-.596.051-.34.448-.596.946-.596.497 0 .894.256.945.596Z"
        fill="#F1F6FA"
      />
      <path
        d="M4.504 21.52c0 .228-.272.414-.608.414-.338 0-.61-.186-.61-.415 0-.227.272-.413.61-.413.336 0 .608.186.608.413Z"
        fill="#1D2943"
      />
      <path
        d="M4.45 21.519c0 .184-.247.334-.552.334-.306 0-.553-.15-.553-.334 0-.183.247-.333.553-.333.305 0 .552.15.552.333Z"
        fill="#31445B"
      />
      <path
        d="M3.87 21.393c0 .07-.09.127-.203.127-.112 0-.203-.057-.203-.127s.09-.127.203-.127c.113 0 .204.057.204.127Z"
        fill="#F1F6FA"
        opacity=".52"
      />
      <path
        d="M5.727 4.458c-.32 0-.64-.188-.598-.473.032-.215.283-.378.598-.378s.567.163.599.378c.043.286-.277.473-.599.473Z"
        fill="#C9CEE2"
      />
      <path
        d="M6.326 3.985c-.033.215-.284.377-.599.377s-.565-.162-.598-.377c.032-.215.283-.378.598-.378s.567.163.599.378Z"
        fill="#F1F6FA"
      />
      <path
        d="M6.111 3.965c0 .144-.172.262-.385.262-.213 0-.385-.118-.385-.262 0-.144.172-.262.385-.262.213 0 .385.118.385.262Z"
        fill="#1D2943"
      />
      <path
        d="M6.077 3.965c0 .117-.156.212-.35.212-.193 0-.35-.095-.35-.212 0-.116.157-.211.35-.211.194 0 .35.095.35.21Z"
        fill="#31445B"
      />
      <path
        d="M5.71 3.885c0 .044-.057.08-.128.08-.072 0-.13-.036-.13-.08 0-.044.058-.08.13-.08.07 0 .128.036.128.08Z"
        fill="#F1F6FA"
        opacity=".52"
      />
      <path
        d="M25.028 11.972c.463 0 .824-.256.824-.582 0-.365-.419-.581-.824-.581-.43 0-.774.221-.819.516-.058.391.38.647.82.647Z"
        fill="#C9CEE2"
      />
      <path
        d="M24.21 11.325c.045.294.387.516.818.516.431 0 .774-.222.819-.516-.044-.295-.388-.516-.819-.516-.43 0-.774.221-.819.516Z"
        fill="#F1F6FA"
      />
      <path
        d="M24.503 11.298c0 .198.236.359.527.359.292 0 .527-.161.527-.359 0-.197-.235-.358-.527-.358-.291 0-.527.161-.527.358Z"
        fill="#1D2943"
      />
      <path
        d="M24.55 11.297c0 .16.214.29.478.29.265 0 .479-.13.479-.29 0-.158-.214-.288-.48-.288-.263 0-.477.13-.477.288Z"
        fill="#31445B"
      />
      <path
        d="M25.052 11.188c0 .06.078.11.176.11.097 0 .176-.05.176-.11s-.079-.11-.176-.11c-.098 0-.177.05-.177.11Z"
        fill="#F1F6FA"
        opacity=".52"
      />
      <path
        d="M26.233 22.575c.534 0 .952-.296.952-.672a.5.5 0 0 0-.006-.076c-.051-.34-.448-.596-.946-.596-.497 0-.894.256-.945.596-.068.453.438.748.945.748Z"
        fill="#C9CEE2"
      />
      <path
        d="M25.288 21.827c.052.34.448.596.945.596.498 0 .894-.256.946-.596-.051-.34-.448-.596-.946-.596-.497 0-.894.256-.945.596Z"
        fill="#F1F6FA"
      />
      <path
        d="M25.627 21.797c0 .228.272.414.608.414.338 0 .61-.186.61-.414 0-.227-.272-.413-.61-.413-.336 0-.608.186-.608.413Z"
        fill="#1D2943"
      />
      <path
        d="M25.681 21.796c0 .185.247.335.552.335.306 0 .553-.15.553-.335 0-.183-.247-.333-.553-.333-.305 0-.552.15-.552.333Z"
        fill="#31445B"
      />
      <path
        d="M26.26 21.67c0 .07.091.127.204.127.113 0 .203-.057.203-.127s-.09-.127-.203-.127c-.113 0-.204.057-.204.127Z"
        fill="#F1F6FA"
        opacity=".52"
      />
      <path
        d="M23.801 4.31c0 .239.265.426.603.426.338 0 .602-.187.602-.425a.324.324 0 0 0-.004-.048c-.032-.215-.283-.377-.598-.377s-.567.162-.599.377a.324.324 0 0 0-.004.048Z"
        fill="#C9CEE2"
      />
      <path
        d="M23.805 4.263c.033.215.284.377.599.377s.565-.162.598-.377c-.032-.215-.283-.377-.598-.377s-.567.162-.599.377Z"
        fill="#F1F6FA"
      />
      <path
        d="M24.02 4.243c0 .144.172.262.385.262.213 0 .386-.118.386-.262 0-.144-.173-.262-.386-.262-.213 0-.385.118-.385.262Z"
        fill="#1D2943"
      />
      <path
        d="M24.054 4.243c0 .117.156.212.35.212.193 0 .35-.095.35-.212 0-.116-.157-.21-.35-.21-.194 0-.35.094-.35.21Z"
        fill="#31445B"
      />
      <path
        d="M24.42 4.163c0 .045.058.081.13.081.07 0 .128-.036.128-.08 0-.045-.057-.081-.129-.081-.07 0-.128.036-.128.08Z"
        fill="#F1F6FA"
        opacity=".52"
      />
    </svg>
  );
}
